<template>
    <section class="inner">
        <div class="left">
            <div class="top">
                <icon-title title="学术研究动态" iconName="jingfeiyongtu"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart1T"></div>
                </div>
                <div class="item-bottom">
                    <div class="chart chart2" id="chart1L"></div>
                    <div class="chart chart2" id="chart1R"></div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="党建" iconName="kejituanzb"></icon-title>
                <div class="chart chart2" id="chart2L"></div>
                <div class="chart chart2" id="chart2R"></div>
            </div>
        </div>
        <div class="center">
            <div class="top">
                <icon-title title="会员地域分布" class="lg" iconName="kjtzbxueke"></icon-title>
                <div class="chart map" id="chart3"></div>
                <div class="map-num">
                    <p>
                        国内会员数： {{ inland }}
                    </p>
                    <p>
                        国外会员数： {{ foreign }}
                    </p>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="智库-学会开展决策咨询工作情况" class="lg" iconName="lingyuhuiyi"></icon-title>
                <div class="chart" id="chart4"></div>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <icon-title title="学术" iconName="wenben"></icon-title>
                <div class="item-top">
                    <div class="chart" id="chart5T"></div>
                </div>
                <div class="item-bottom table-box">
                    <div class="chart" id="chart5L"></div>
                    <div class="table">
                        <h4>
                            奖项申请系统中获奖情况
                        </h4>
                        <table>
                            <thead>
                                <tr>
                                    <th width="60%">
                                        名称
                                    </th>
                                    <th>
                                        获奖学者数
                                    </th>
                                </tr>
                            </thead>
                        </table>
                        <div class="part5-table" v-if="part5Label" ref="part5List">
                            <table>
                                <tr v-for="(item, index) in part5Label.column" :key="index">
                                    <td width="60%">
                                        {{ item }}
                                    </td>
                                    <td>
                                        <i>
                                            {{ part5Label.list[index] }}
                                        </i>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <icon-title title="科普-学会举办科普活动情况" iconName="ningjuli1"></icon-title>
                <div class="chart" id="chart6"></div>
            </div>
        </div>
    </section>
</template>
<script>
    import IconTitle from '@/components/icontitle';
    import * as dataJS from '@/assets/scripts/api/ybj';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const barColor = [ '#06C0FB', '#2F46C1', '#FB058F', '#EF9412', '#30CF6F','#30CF70'];
    const mapColor = ['#8592FF', '#6978FF', '#4E60F9', '#384DDF', '#293FCA', '#1831B2'];
    const pieColor = [
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        },
        {
            'line': '#30CF70',
            'area': 'rgba(48,207,112,.2)'
        },
        {
            'line': '#EF9412',
            'area': 'rgba(239,148,18,.2)'
        },
        {
            'line': '#05C0FB',
            'area': 'rgba(5,192,251,.2)'
        },
        {
            'line': '#FB058F',
            'area': 'rgba(251,5,143,.2)'
        }
    ];

    const XAXIS = {
        type: 'category',
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 14
            }
        },
        axisLine: {
            lineStyle: {
                color: lineColor
            }
        },
        splitLine: {
            show: false
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                color: lineColor,
            }
        }
    };
    const YAXIS = {
        axisTick: {
            show: false
        },
        axisLine: {
            show: false
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: lineColor,
                type: 'dotted'
            }
        },
        axisLabel: {
            show: true,
            textStyle: {
                color: labelColor,
                fontSize: 12
            },
            formatter: '{value}'
        }
    };

    export default {
        name: 'hxh',
        components: {
            IconTitle
        },
        data() {
            return {
                part5Label: {},
                foreign: '',
                inland: '',
                grid: {
                    x: '5%',
                    x2: '7%',
                    y: '10%',
                    containLabel: true
                }
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

                // 学术研究动态
                dataJS.getTrends().then((res) => {
                    this.initChart1(res.data);
                });

                // 党建设
                dataJS.getHparty().then((res) => {
                    this.initChart2(res.data);
                });

                // 会员地域分布
                dataJS.getVipDistribute().then((res) => {
                    this.foreign = res.data.foreign;
                    this.inland = res.data.inland;
                    this.initChart3(res.data.map);
                });

                // 智库
                dataJS.getHidea().then((res) => {
                    this.initChart4(res.data.edu);
                });

                // 学术-学会举办的各类学术活动情况
                dataJS.getHtrafficMeet().then((res) => {
                    this.part5Label = res.data.three;
                    this.initChart5(res.data);
                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.part5List);
                    });
                });

                // 科普-学会举办科普活动情况
                dataJS.getHkepu().then((res) => {
                    this.initChart6(res.data);
                });

            },
            initChart1(data) {
                let chart1L = echarts.init(document.getElementById('chart1L')),
                    chart1R = echarts.init(document.getElementById('chart1R')),
                    optionL = this.getRadarOption(data.two, '中国近五年各领域论文发文量占比'),
                    optionR = this.getRadarOption(data.three, '中国近五年各领域引文影响力'),
                    chart1T = echarts.init(document.getElementById('chart1T')),
                    optionT = this.getBarData(data.one, '近五年全球论文发文量', 'bar');

                chart1L.setOption(optionL, true);
                chart1L.resize();
                this.$winResize(chart1L.resize);
                chart1R.setOption(optionR, true);
                chart1R.resize();
                this.$winResize(chart1R.resize);
                chart1T.setOption(optionT, true);
                chart1T.resize();
                this.$winResize(chart1T.resize);
            },
            initChart2(data) {
                let chart2L = echarts.init(document.getElementById('chart2L')),
                    chart2R = echarts.init(document.getElementById('chart2R')),
                    optionL = this.getPieOption(data.action, '党建活动类型分布'),
                    optionR = this.getPieOption(data.office, '党员任职分布');

                chart2L.setOption(optionL, true);
                chart2L.resize();
                this.$winResize(chart2L.resize);
                chart2R.setOption(optionR, true);
                chart2R.resize();
                this.$winResize(chart2R.resize);
            },
            initChart3(data) {
                let chinaMap = echarts.init(document.getElementById('chart3')),
                    {mapData, rangeData} = this.returnMapSeriesData(data);

                let mapOpts = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}'
                    },
                    geo: {
                        show: true,
                        map: 'china',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#090D28',
                                borderWidth: 1,
                                areaColor: '#8592FF',
                                shadowColor: 'rgba(133,146,255,.3)',
                                shadowBlur: 50
                            },
                            emphasis: {
                                areaColor: '#4E60F9'
                            }
                        }
                    },
                    visualMap: {
                        min: rangeData.min,
                        max: rangeData.max,
                        show: false,
                        calculable: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [{
                        type: 'map',
                        geoIndex: 0,
                        data: mapData
                    }]
                };

                chinaMap.setOption(mapOpts, true);
                chinaMap.resize();
                this.$winResize(chinaMap.resize);
            },
            initChart4(data) {
                let chart4 = echarts.init(document.getElementById('chart4')),
                    option = this.getLineData(data);

                chart4.setOption(option, true);
                chart4.resize();
                this.$winResize(chart4.resize);
            },
            initChart5(data) {
                let chart5T = echarts.init(document.getElementById('chart5T')),
                    chart5L = echarts.init(document.getElementById('chart5L')),
                    optionT = this.getBarData(data.one, '学会举办的各类学术活动情况', 'complex'),
                    optionL = this.getLineData(data.two, '会议系统中会议的上线数量', 'symbol');

                chart5T.setOption(optionT, true);
                chart5T.resize();
                this.$winResize(chart5T.resize);
                chart5L.setOption(optionL, true);
                chart5L.resize();
                this.$winResize(chart5L.resize);
            },
            initChart6(data) {
                let chart6 = echarts.init(document.getElementById('chart6')),
                    option = this.getBarData(data, '', 'complex', true);

                chart6.setOption(option, true);
                chart6.resize();
                this.$winResize(chart6.resize);
            },
            getBarData(data, title, type) {
                let seriesData = [],
                    option,
                    yAxis = YAXIS;

                switch (type) {
                case 'complex':
                    yAxis = this.returnComplexData(data).yAxis;
                    seriesData = this.returnComplexData(data).seriesData;
                    break;
                case 'bar':
                    seriesData = this.returnBarData(data);
                    break;
                }

                option = {
                    title: {
                        text: title,
                        x: 10,
                        y: 10,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        top: title ? '20%' : '10%',
                        bottom: type == 'bar' ? '5%' : '13%',
                        containLabel: true
                    },
                    legend: {
                        bottom: '0',
                        data: data.title,
                        itemWidth: 15,
                        itemHeight: 15,
                        textStyle: {
                            color: labelColor,
                        }
                    },
                    xAxis: Object.assign({
                        data: data.column
                    }, XAXIS),
                    yAxis: yAxis,
                    series: seriesData
                };

                return option;
            },
            returnBarData(data) {
                let seriesData = [];

                seriesData.push({
                    type: 'bar',
                    barWidth: '25%',
                    barGap: 1,
                    name: '',
                    itemStyle: {
                        normal: {
                            show: true,
                            color: barColor[0]
                        }
                    },
                    data: data.list
                });


                return seriesData;
            },
            returnComplexData(data) {
                let seriesData = [],
                    yAxis,
                    max1 = Math.max.apply(null, data.list[0]),
                    max2 = Math.max.apply(null, data.list[1]);

                seriesData = [
                    {
                        name: data.title[0],
                        type: 'bar',
                        barWidth: '25%',
                        itemStyle: {
                            normal: {
                                color: barColor[0]
                            }
                        },
                        data: data.list[0]
                    },
                    {
                        name: data.title[1],
                        type: 'line',
                        symbol: 'none',
                        itemStyle: {
                            normal: {
                                color: barColor[2]
                            }
                        },
                        yAxisIndex: 1,
                        data: data.list[1]
                    }];

                yAxis = [
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max1,
                    }, YAXIS),
                    Object.assign({
                        type: 'value',
                        min: 0,
                        max: max2
                    }, YAXIS)
                ];

                return {seriesData, yAxis};
            },
            getPieOption(data, name) {
                let seriesData = [],
                    option = {};

                data.list.forEach((item, index) => {
                    let obj = {};

                    obj.value = parseFloat(item);
                    obj.name = data.column[index];

                    if (index == 0) {
                        obj.selected = true;
                    }
                    seriesData.push(obj);
                });

                option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    title: {
                        text: name,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: '5%',
                        left: '5%'
                    },
                    grid: {
                        left: '0',
                        right: '0',
                        bottom: '13%',
                        top: '20%',
                        containLabel: true
                    },
                    color: barColor,
                    series: [{
                        name: '',
                        type: 'pie',
                        radius: [0, '60%'],
                        center: ['50%', '60%'],
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };

                return option;
            },
            getLineData(data, title, type) {
                let seriesData = [],
                    option;

                if (type){
                    seriesData.push({
                        name: '',
                        type: 'line',
                        symbol: 'circle',
                        smooth: true,
                        itemStyle: {
                            normal: {
                                color: pieColor[0].line,
                                lineStyle: {
                                    color: pieColor[0].line
                                }
                            },
                        },
                        areaStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: pieColor[0].line
                                }, {
                                    offset: 1,
                                    color: pieColor[0].area
                                }])
                            }
                        },
                        data: data.list
                    });
                }else {
                    data.list.forEach((item, index) => {

                        seriesData.push({
                            name: data.title[index] ,
                            type: 'line',
                            symbol: 'circle',
                            smooth: true,
                            itemStyle: {
                                normal: {
                                    color: pieColor[index].line,
                                    lineStyle: {
                                        color: pieColor[index].line
                                    }
                                },
                            },
                            areaStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: pieColor[index].line
                                    }, {
                                        offset: 1,
                                        color: pieColor[index].area
                                    }])
                                }
                            },
                            stack: "总量",
                            data: item
                        });
                    });
                }

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: 0,
                        left: '5%'
                    },
                    color: barColor,
                    grid: {
                        left: '5%',
                        right: '7%',
                        top: title ? '20%' : '10%',
                        bottom: '10%',
                        containLabel: true
                    },
                    legend: {
                        itemWidth: 6,
                        itemHeight: 6,
                        icon: 'circle',
                        data: data.title,
                        bottom: 0,
                        textStyle: {
                            color: labelColor
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: Object.assign({
                        data: data.column
                    }, XAXIS),
                    yAxis: YAXIS,
                    series: seriesData
                };

                return option;

            },
            getRadarOption(data, title) {
                let indicatorData = [],
                    option;

                let list = data.list.map(item => {
                    return parseFloat(item);
                });

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, list),
                        obj = {
                            name: item,
                            min: 0,
                            max: max,
                        };

                    indicatorData.push(obj);
                });

                option = {
                    title: {
                        text: title,
                        textStyle: {
                            color: labelColor,
                            fontSize: 13
                        },
                        top: 0,
                        left: '5%'
                    },
                    grid: {
                        position: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: () => {
                            let str = '';

                            data.list.forEach((item, index) => {
                                str += `${data.column[index]}:${item}<br/>`;
                            });

                            return str;
                        }
                    },
                    radar: {
                        radius: '45%',
                        center: ['50%', '60%'],
                        splitNumber: 3,
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        name: {
                            formatter: function (value) {
                                if (value.length > 4) {
                                    value = value.slice(0, 3) + '\n' + value.slice(3);
                                }
                                return value;
                            },
                            textStyle: {
                                color: labelColor,
                                fontSize: 12
                            }
                        },
                        indicator: indicatorData
                    },
                    series: [{
                        type: 'radar',
                        name: '',
                        data: [{
                            value: list
                        }],
                        symbolSize: 8,
                        lineStyle: {
                            color: pieColor[0].line
                        },
                        areaStyle: {
                            color: pieColor[0].area,
                            opacity: 0.5
                        },
                        itemStyle: {
                            color: pieColor[0].line,
                            borderWidth: 2
                        }
                    }]
                };

                return option;
            },
            returnMapSeriesData(data) {
                let valueArr = [],
                    rangeData = {};

                let mapData = data.map(item => {
                    let _item = {};

                    _item.value = item.deep;
                    _item.name = item.name;
                    _item.tooltip = {
                        formatter: function () {
                            let tips = '<div class="tips-panel">';

                            for (let key in item.list) {
                                tips += `<p><span style="padding-right:5px">${key}</span>:${item.list[key]}</p>`;
                            }
                            tips += '</div>';
                            return tips;
                        }
                    };
                    valueArr.push(item.deep);

                    rangeData.min = Math.min.apply(null, valueArr);
                    rangeData.max = Math.max.apply(null, valueArr);
                    return _item;
                });

                return {mapData, rangeData};
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import "~@/assets/scss/mixins/_mixins.scss";

    $titleColor: #B5C8FF;
    $borderColor: #17215F;
    $borderDrakColor: #080B26;

    .inner {
        padding: 2% 2.08% 0;
        font-size:.16rem;

        ::v-deep.title-line-main {
            margin-right: 0 !important;
        }

        .top {
            height: 50%;
        }

        .bottom {
            height: 50%;
        }

        .left {
            float: left;
            width: 29.1666666667%;
            height: 100%;

        }

        .right {
            @extend .left;
            float: right;
        }

        .center {
            float: left;
            width: 38.499167%;
            height: 100%;
            margin: 0 1.5%;
        }

        .top {
            height: 56.8%;
            position: relative;
        }

        .bottom {
            height: 39.1%;
        }

        .item-top{
            width:100%;
            height: 50%;
        }

        .item-bottom{
            width:100%;
            height: calc(50% - 34px);
        }


        .chart {
            width: 100%;
            height: 100%;
        }

        .chart2{
            width:50%;
            float: left;
        }


        .map {
            position: relative;
            background: url('~@/assets/images/mapbg.png') no-repeat top center / 100% auto;

            &:after {
                display: inline-block;
                content: '';
                width: 83.77%;
                height: 9.875%;
                background: url('~@/assets/images/mapline.png') no-repeat center center / 100% 100%;
                @include position(absolute, auto, auto, 5.49%, 50%);
                transform: translateX(-50%);
            }
        }

        .map-num{
            font-size:.24rem;
            line-height: .4rem;
            color: #ffc02f;
            @include position(absolute, auto, auto, 5%, 5%);
            p:first-child {
                color: #4295fe;
            }
        }

        .table-box {

            overflow: hidden;
            h4 {
                line-height: .35rem;
                color: $titleColor;
                padding-left: 10px;
                border-bottom: 1px solid $borderColor;
                background: #12173c;
            }
            .table {
                float: right;
                width: 45%;
                height: 100%;
                overflow: hidden;
                font-size: .75em;
                border:{
                    left: 1px solid $borderColor;
                    right: 1px solid $borderColor;
                }
                table {
                    width: 100%;
                    text-align: center;
                    font-size: .875em;
                    height: 30px;
                }
                .part5-table {
                    height: calc(100% - .3rem);
                    overflow: hidden;
                    border-bottom: 1px solid $borderColor;
                }
                thead {
                    border-bottom: 1px solid $borderColor;
                }
                tr {
                    height: .3rem;
                    border-bottom: 1px solid $borderColor;
                    &:last-child {
                        border: none;
                    }
                }
                td, th {
                    border-right: 1px solid $borderColor;
                    &:last-child {
                        border: none;
                    }
                    &:first-child {
                        color: $titleColor;
                    }
                }
                td {
                    height: .3rem;
                    line-height:.3rem;
                }
                th {
                    color: #86b9f6;
                    background: #12173c;
                    height: .3rem;
                    &:first-child {
                        color: $titleColor;
                    }
                }
                i {
                    color: #ffc02f;
                }
            }
            .chart {
                width: 55%;
                float: left;
            }
        }
    }

</style>